export default __webpack_public_path__ + "static/bg-ford--mobile-17a24d326ed1be6878e2d14c83936519.jpeg";